<template lang="pug">
#product
  .product_header
    headroom(
      :offset="headerHeight + 20",
      :classes="{ initial: 'initial', pinned: 'pinned', unpinned: 'unpinned' }"
    )
      .navs_wrapper
        .container-fluid(
          :class="{ bg_g_blue_ci: productCategorySelect.Style == '1', bg_g_blue: productCategorySelect.Style == '2' }"
        )
          nav.d-flex.flex-wrap.justify-content-center
            nav-tab(
              v-for="(productCategory, index) in productCategory.ProductCategoryList",
              :key="index",
              :title="productCategory.ProductCategoryName",
              :selected="selectedLink == index",
              @click.native="changeTab(index)"
            )

        .nav_wrapper.d-flex.align-items-center.justify-content-center(
          :class="{ bg_light_blue: productCategorySelect.Style == '1', bg_blue: productCategorySelect.Style == '2' }"
        )
          .scroll_sign.left.d-md-none(v-if="scrollLeftSide")
            svg-icon(iconClass="triangle", className="triangle")
          nav.scrollable_tab_nav(@scroll="scrollEvent")
            .tabs.flex_h
              .tab_(
                v-for="(tab, index) in productCategoryDetail.ProductList",
                :key="index"
              )
                scrollable-tab(
                  :title="tab.ProductNickName",
                  :img="tab.ProductIcon",
                  :selected="selectedSubLink == index",
                  @click.native="changeSubTab(index)"
                )

          .scroll_sign.right.d-md-none(v-if="scrollRightSide")
            svg-icon(iconClass="triangle", className="triangle")
  .product_body(:style="{ marginTop: headerHeight + 'px' }")
    section.btn_section.container.container_shrink
      .row.btn_section_inner.container_shrink.m-auto.justify-content-md-between.i_pt_5
        .col-12.btn_container.d-flex.flex-column.flex-md-row.justify-content-md-between.align-items-md-center
          h2.i_h2_title {{ productDetail.ProductName }}
          .selector_round_btns
            .selector_round_btn.i_ml_1(
              v-for="(btn, index) in btns",
              :key="index",
              :class="{ blue: $store.state.navigationStyle == 2, selected: selectedBtn == index && $store.state.navigationStyle == 1, business: selectedBtn == index && $store.state.navigationStyle == 2 }",
              @click="changebtn(index)"
            ) {{ btn.title }}
    hr
    transition(name="page", mode="out-in")
      router-view.i_mt_4(
        :productDetail="productDetail",
        :productCategorySelectStyle="productCategorySelect.Style"
      )
    custom-footer(@footerProductClick="footerProductClick")
</template>

<script>
import { getProductCategory, getProductDetail } from "@/json/product";
import ScrollableTab from "@/components/product/ScrollableTab";
import NavTab from "@/components/product/NavTab";
import CustomFooter from "@/components/common/Footer";
import { headroom } from "vue-headroom";

export default {
  name: "Product",
  metaInfo() {
    return {
      title: this.productDetail.SEO_Title,
      meta: [{ name: "description", content: this.productDetail.SEO_Description }],
    };
  },
  props: {
    freshFlag: Number,
  },
  components: {
    "custom-footer": CustomFooter,
    "nav-tab": NavTab,
    "scrollable-tab": ScrollableTab,
    headroom,
  },
  data() {
    return {
      // initial: {
      //   marginTop: "95px",
      // },
      screenWidth: document.documentElement.clientWidth, //螢幕寬度
      headerHeight: 0,
      headTitle: "汽車第三人責任保險",
      btns: [],
      btnsStyle0: [
        {
          title: "商品介紹",
        },
        {
          title: "詳細說明",
        },
        {
          title: "理賠資訊",
        },
      ],
      btnsStyle1: [
        {
          title: "商品介紹",
        },
        {
          title: "詳細說明",
        },
        {
          title: "理賠資訊",
        },
        {
          title: "網路投保",
        },
      ],
      productCategory: {},
      productCategorySelect: {},
      productCategoryDetail: {},
      productDetail: {},
      selectedLink: 0,
      selectedSubLink: undefined,
      selectedBtn: 0,
      scrollLeftSide: false,
      scrollRightSide: true,

      initSelectLink: undefined,
      initSelectSubLink: undefined,
    };
  },
  created() {
    this.getProductCategory();
  },
  mounted() {
    this.onResize();
  },
  methods: {
    onResize() {
      var thiz = this;

      window.onresize = function () {
        // 定義視窗大小變更通知事件
        thiz.$store.state.screenWidth = document.documentElement.clientWidth; //視窗寬度
      };
    },
    changeTab(index) {
      this.selectedLink = index;
      this.productCategorySelect = this.productCategory.ProductCategoryList[
        this.selectedLink
      ];
      this.productCategoryDetail = this.productCategory.ProductCategoryList[
        this.selectedLink
      ];
      this.$store.commit("setNavigationStyle", this.productCategorySelect.Style);
      if (this.initSelectSubLink) {
        this.changeSubTab(this.initSelectSubLink);
        this.initSelectSubLink = undefined;
      } else {
        this.changeSubTab(0);
      }
    },
    changeSubTab(index) {
      this.selectedSubLink = index;
      this.getProductDetail(this.productCategoryDetail.ProductList[index].ProductJson);
      this.changebtn(0);
    },
    changebtn(index) {
      if (index == 3) {
        window.open(this.productDetail.WebInsuredUrl);
      } else {
        this.selectedBtn = index;
        if (index == 0) {
          this.$router.push({
            name: "ProductIntro",
            params: {
              type: this.productCategoryDetail.ProductList[this.selectedSubLink]
                .ProductJson,
            },
          });
        } else if (index == 1) {
          this.$router.push({
            name: "ProductDescription",
            params: {
              type: this.productCategoryDetail.ProductList[this.selectedSubLink]
                .ProductJson,
            },
          });
        } else if (index == 2) {
          this.$router.push({
            name: "ProductCliamSettlementIntro",
            params: {
              type: this.productCategoryDetail.ProductList[this.selectedSubLink]
                .ProductJson,
            },
          });
        }
      }
      window.scrollTo(0, 0);
    },
    getProductCategory() {
      getProductCategory().then((response) => {
        this.productCategory = response.data;
        if (this.$route.params.type) {
          for (let linkIndex in this.productCategory.ProductCategoryList) {
            let tempLink = this.productCategory.ProductCategoryList[linkIndex];
            for (let subLinkIndex in tempLink.ProductList) {
              let tempSubLink = tempLink.ProductList[subLinkIndex];
              if (tempSubLink.ProductJson == this.$route.params.type) {
                this.initSelectLink = linkIndex;
                this.initSelectSubLink = subLinkIndex;
              }
            }
          }
          this.changeTab(this.initSelectLink);
        } else {
          this.changeTab(0);
        }
      });
    },
    getProductDetail(JSON) {
      if (JSON && JSON != "") {
        getProductDetail(JSON).then((response) => {
          this.productDetail = response.data;
          if (this.productDetail.WebInsured == "0") {
            this.btns = this.btnsStyle0;
          } else if (this.productDetail.WebInsured == "1") {
            this.btns = this.btnsStyle1;
          }

          this.$nextTick(() => {
            this.headerHeight = document.querySelector(".navs_wrapper").offsetHeight + 20;
          });
        });
      }
    },
    scrollEvent(e) {
      if (e.srcElement.scrollLeft == 0) {
        this.scrollLeftSide = false;
      } else {
        this.scrollLeftSide = true;
      }

      if (
        Math.ceil(e.srcElement.scrollLeft) + e.srcElement.offsetWidth >=
        e.srcElement.scrollWidth
      ) {
        this.scrollRightSide = false;
      } else {
        this.scrollRightSide = true;
      }
    },
    footerProductClick() {
      this.getProductCategory();
    },
  },
  watch: {
    "$store.state.screenWidth": function () {
      this.headerHeight = document.querySelector(".navs_wrapper").offsetHeight + 20;
    },
    freshFlag() {
      if (this.freshFlag != 0) {
        this.getProductCategory();
      }
    },
    $route(to, from) {
      if ("ProductIntro" == to.name) {
        this.selectedBtn = 0;
      } else if ("ProductDescription" == to.name) {
        this.selectedBtn = 1;
      } else if ("ProductCliamSettlementIntro" == to.name) {
        this.selectedBtn = 2;
      }

      if (to.params.type != from.params.type) {
        this.getProductCategory();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/product/product";
</style>

<style lang="scss">
.initial {
  top: 90px !important;
  z-index: 2 !important;
}

@media (max-width: 991px) {
  .initial {
    top: 72px !important;
  }
}
@media (max-width: 767px) {
  .initial {
    top: 142px !important;
  }
}
@media (max-width: 575px) {
  .initial {
    top: 127px !important;
  }
}
</style>
